<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="deserts"
            >
            <template v-if="canEdit" v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>เพิ่มรายการอะไหล่</v-toolbar-title>
                </v-toolbar>
                <v-divider
                    class="mx-4"
                    inset
                    ></v-divider>
                <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                    <v-row class="ml-2">
                        <v-col>
                            <v-autocomplete
                                v-model="selectedParts"
                                :items="partsList"
                                item-text="partsTextDisplay"
                                item-value="partsCode"
                                outlined 
                                placeholder="พิมพ์รหัส หรือ ชื่ออะไหล่"
                                return-object
                                :rules="[rules2.requiredObject]"
                                label="อะไหล่">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " :rules="[rules.requiredNumber]" label="จำนวน" maxlength="4" v-model="editedItem.qty"></v-text-field></v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " disabled label="ราคา/หน่วย" v-model="editedItem.unitPrice"></v-text-field></v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " :rules="[rules.requiredMaxNumber(100)]" label="ส่วนลด" maxlength="6" v-model="editedItem.discountPercent"></v-text-field></v-col>
                        <v-col cols="2" md="3">
                            <v-btn class="ma-2" color="primary" @click="saveDetail">เพิ่ม</v-btn>
                            <v-btn class="ma-2" color="primary" @click="closeDialog"> ล้าง</v-btn>
                        </v-col>
                    </v-row>
                </v-form> 
            </template>
            <template v-slot:header.discount>
                <thead>
                    <tr>
                        <th colspan="2" class="text-center">ส่วนลด</th>
                    </tr>
                    <tr>
                        <th class="text-center">%</th>
                        <th class="text-center">ยอด</th>
                    </tr>
                </thead>
            </template>
            <template v-slot:item.discount="{item}">
                                <tr>
                                    <th class="text-center">{{item.discountPercentDisplay}}</th>
                                    <th class="text-center">{{item.discountPriceDisplay}}</th>
                                </tr>
                            </template>
            <template v-if="canEdit && !isReceiveParts" v-slot:item.action="{ item }">
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
        </v-data-table>
    </v-container>
</template>

<script>
import {listDropdownBpeParts} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'
import rules from '@/assets/js/rules.js'
export default {
    name: 'BpeParts',
    props: ["branchCode", "brandCode", "currentItems", "canEdit", "isReceiveParts"],
    computed: {
        deserts() {
            return this.currentItems ? this.currentItems : this.items;
        }
    },
    watch: {
        selectedParts(parts) {
            this.editedItem.partsCode = parts.partsCode;
            this.editedItem.partsName = parts.partsName;
            this.editedItem.unitPrice = parts.unitPrice;
        },
        items: {
            handler(data){
                this.$emit("syncBpeParts", data);
            },
            deep: true
        },
        currentItems(val) {
            if (val) this.items = val;
        }
    },
    data: () => ({
        discount: 0,
        rules2: {
            requiredObject: value => {
                return !!value.partsCode || 'Required.'
            }
        },
        rules: rules,
        headers: [
            {text: 'No.', value: 'no'},
            {text: 'รหัสอะไหล่', value: 'partsCode'},
            {text: 'ชื่อรายการอะไหล่', value: 'partsName'},
            {text: 'จำนวน', value: 'qty'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay'},
            {text: 'ยอดรวม', value: 'totalDisplay'},
            {text: 'ส่วนลด(%)', value: 'discountPercent'},
            {text: 'รวมสุทธิ', value: 'grandTotalDisplay'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [],
        editedItem: {
            no: 0,
            partsCode: '',
            partsName: '',
            qty: '',
            unitPrice: '',
            total: 0,
            discountPercent: 0,
            grandTotal: 0,
            dirty: false
        },
        defaultItem: {
            no: 0,
            partsCode: '',
            partsName: '',
            qty: '',
            unitPrice: '',
            total: 0,
            discountPercent: 0,
            grandTotal: 0,
            dirty: false
        },
        validDetail: false,
        partsList: [],
        selectedParts: {}
    }),
    methods: {
        calulateDiscount() {
            //this.editedItem.discountPercent = this.discount;
            this.editedItem.total = this.editedItem.qty * this.editedItem.unitPrice;
            this.editedItem.discountPrice = this.editedItem.discountPercent == 0 ? 0 : this.editedItem.total * this.editedItem.discountPercent / 100;
            this.editedItem.grandTotal = this.editedItem.total - this.editedItem.discountPrice;
            this.setDisplay(this.editedItem);
        },
        setDisplay(obj) {
            obj.discountPercentDisplay = numeral(obj.discountPercent).format('0,0.00');
            obj.totalDisplay = numeral(obj.total).format('0,0.00');
            obj.discountPriceDisplay = numeral(obj.discountPrice).format('0,0.00');
            obj.grandTotalDisplay = numeral(obj.grandTotal).format('0,0.00');
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            this.editedItem.dirty = true;
            this.editedItem.no = this.items.length + 1;
            this.editedItem.unitPriceDisplay = numeral(this.editedItem.unitPrice).format('0,0.00');
            this.calulateDiscount();
            this.items.push(this.editedItem);
            this.closeDialog();
        },
        closeDialog() {
            this.$nextTick(() => {
                this.selectedParts = Object.assign({}, {});
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedItem.discountPercent = this.discount;
            });
        },
        deleteItem (item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return;
            }
            const index = this.items.indexOf(item);
            this.items.splice(index, 1);
        },
        clearData() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.selectedParts = Object.assign({}, {});
            this.items = [];
        },
        setDiscount(val) {
            this.discount = val;
        },
        loadDropdown(brandCode) {
            this.$loading(true);
            listDropdownBpeParts(brandCode).then(rs => {
                this.$loading(false);
                this.partsList = rs;
            }).catch(() => {
                this.$loading(false);
            });
        }
    },
    mounted() {
        this.editedItem.discountPercent = this.discount;
        /*
        if (this.brandCode) {
            this.loadDropdown(this.brandCode);
        }
        */
    }
}
</script>